'use strict';
/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
var trackingUtils = require('../modules/utils/tracking.utils');
var PAYMENT_METHOD = {
    0: 'cheapest_payment_method',
    1: 'visa_credit',
    2: 'mastercard_credit',
    4: 'visa_debit',
    8: 'mastercard_debit',
    9: 'american_express',
    12: 'visa_entropay',
    15: 'agos_edreams',
};
var LABELS = {
    date0: 'date_departure_leg_1_error',
    date1: 'date_arrival_leg_1_error',
    departure: 'location_departure_leg_1_error',
    destination: 'location_arrival_leg_1_error',
    checkSeparateStay: 'separate_stay_search_',
    getError: function(searchType) {
        return 'search_' + searchType + '_FE_error';
    },
    directFlights: 'direct_flights_checked',
    cabinClass: 'cabin_class_',
    numPax: 'number_pax_',
};
var NewSearchTracking = function(options) {
    this.opts = options;
    this.action = options.action;
};

_.extend(NewSearchTracking.prototype, {
    getRoomsLabel: function(searchParams) {
        return _.reduce(searchParams.rooms, function(label, room, index) {
            return label += '_num:' + (++index) +
                '_adu:' + room.numAdults +
                '_child:' + room.childrenAges.length +
                '_inf:' + room.infantsAges.length;
        }, 'rooms:' + searchParams.numberOfRooms);
    },

    getPayMethodLabel: function(searchParams) {
        return 'payment_method_apply_' + _.property(searchParams.collectionMethod)(PAYMENT_METHOD);
    },

    getCheckBoxSeparateStayLabel: function(searchParams) {
        var state = searchParams.checkInDate !== searchParams.searchSegments[0].dateStr ||
            searchParams.checkOutDate !== searchParams.searchSegments[1].dateStr ? 'YES' : 'NO';

        return LABELS.checkSeparateStay + state;
    },

    getPaxLabel: function(searchParams) {
        var paxCombination = searchParams.numAdults + '_' + searchParams.numChildren + '_' + searchParams.numInfants;
        var oldSearchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('oldSearchParameters'));
        var oldPaxCombination = '_old_' + oldSearchParams.numAdults + '_' + oldSearchParams.numChildren + '_' + oldSearchParams.numInfants;

        return LABELS.numPax + paxCombination + oldPaxCombination;
    },

    getCabinClassLabel: function(searchParams) {
        return LABELS.cabinClass + searchParams.cabinClass.toLowerCase();
    },

    getDirectFlightsOnlyLabel: function() {
        return LABELS.directFlights;
    },

    getInvalidErrorLabel: function(error) {
        var errorLabel = 'date' === error.key ? error.key + error.index : error.key;

        return LABELS[errorLabel];
    },

    setAction: function(action) {
        this.action = action;
    },

    isValidPaymentMethod: function(paymentMethod) {
        var validFunnels = ['home', 'flights', 'dp', 'upsell'];
        var validMethod = parseInt(paymentMethod, 10);

        return !_.isNaN(validMethod) && _.isNumber(validMethod) &&
            _.includes(_.keys(PAYMENT_METHOD), paymentMethod) &&
            _.includes(validFunnels, Odigeo.Utils.getAppInGlobalScope());
    },

    getInvalidTypeErrors: function(errors) {
        return _.filter(errors, function(error) {
            return 'date' === error.key || 'invalid' === error.type;
        });
    },

    trackEventsOnSubmit: function(searchParams) {
        if ('searcher_flights' === this.action) {
            trackingUtils.trackEvent(this.action, this.getPaxLabel(searchParams), this.opts.page);
            trackingUtils.trackEvent(this.action, this.getCabinClassLabel(searchParams), this.opts.page);
            if ($('.ip_direct_flight_switcher').is(':checked')) {
                trackingUtils.trackEvent(this.action, this.getDirectFlightsOnlyLabel(), this.opts.page);
            }
        } else {
            trackingUtils.trackEvent(this.action, this.getRoomsLabel(searchParams), this.opts.page);

            if ($('#check-separatestay').is(':checked')) {
                trackingUtils.trackEvent(this.action, this.getCheckBoxSeparateStayLabel(searchParams), this.opts.page);
            }
        }
    },

    trackEventsOnError: function(errors, searchType) {
        var invalidTypeErrors = this.getInvalidTypeErrors(errors);

        trackingUtils.trackEvent(this.action, LABELS.getError(searchType), this.opts.page);

        _.each(invalidTypeErrors, (error) => {
            trackingUtils.trackEvent(this.action, this.getInvalidErrorLabel(error), this.opts.page);
        });
    },
});

module.exports = function(options) {
    return new NewSearchTracking(options || {});
};
